<template>
    <div id="copy-candidate-from-modal" class="hidden modal-new">
        <btnClose v-if="project.id"></btnClose>
        <span class="title">Copy Candidate From</span>

        <div class="modal-body-container">
            <div v-for="bin of copyCandidateFromProjectTree" :key="bin.key" class="bin-container">
                <v-expansion-panels :value="expanded" accordion>
                    <v-expansion-panel expand>
                        <v-expansion-panel-header>
                            <span class="bin-name">{{ bin.name }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="assets-container">
                                <div v-for="asset of bin.children" :key="asset.key" class="asset-container">
                                    <v-lazy v-if="asset.type == 'candidate'">
                                        <Thumbnail :item="asset" @click.native="selectedItem = asset" :class="{ '--selected': selectedItem && selectedItem.key == asset.key }" />
                                    </v-lazy>
                                    <span class="asset-name">{{ nicename(asset.name) }}</span>
                                </div>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>

        <div class="buttons-continer">
            <button :class="{ '--disabled': inProcess }" :disabled="!selectedItem" class="modal-btn --primary"
                    type="button" @click="onConfirm"
            >
                <v-progress-circular v-if="inProcess" color="#fff" indeterminate size="18" width="3"
                ></v-progress-circular>
                <span v-else>Copy</span>
            </button>
            <button class="modal-btn --cancel" type="button" @click="onCancel">Cancel</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import btnClose from "@/components/app/buttons/modal/Close";
import FilenameMixin from "@/mixins/Filename";
import Thumbnail from "@/components/app/projects/Thumbnail";

export default {
    mixins: [FilenameMixin],

    components: {
        btnClose,
        Thumbnail
    },

    data() {
        return {
            expanded: 0,
            selectedItem: null,
            inProcess: false,
        };
    },
    computed: {
        ...mapState("Projects", ["project", "copyCandidateFromProjectTree"]),
        ...mapGetters("Projects", ["thumbnail"]),
    },

    methods: {
        ...mapActions("Helpers", ["revokeObjectURL"]),

        nicename(name, stripTimestampOnly = false) {
            if (stripTimestampOnly) return this.stripTimestamp(name);
            else return this.stripTimestampAndExtension(name);
        },

        async onConfirm() {
            if (this.inProcess) return;
            this.inProcess = true;
            vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

            await this.copyCandidate();

            vm.$store.dispatch("Loader/showProgressBar", false);

            this.inProcess = false;
            this.selectedItem = null;

            window.UI.hideModal();
        },

        async copyCandidate() {
            let clonedCandidate = await this.$store.dispatch("Projects/copyCandidateFrom", {
                file_id: this.$store.state.Projects.action.data[0].id,
                file_ids: this.$store.state.Projects.action.data.map(e => e.id),
                candidate_id: this.selectedItem.id,
            });

            await this.$store.dispatch("Projects/refreshProjectTree");

            if (this.$store.state.Projects.action.data.length == 1) window.UI.message.activate("Candidate copied successfully");
            else window.UI.message.activate("Candidates copied successfully");

            // this.$store.dispatch("Projects/fetchThumbnails");

            if (this.$store.state.Projects.action.data.map(e => e.id).includes(this.$store.state.Projects.image)) {
                window.lutify.switchCandidates(this.$store.state.Projects.image);

                // await new Promise(resolve => {
                //     let interval = setInterval(async () => {
                //         let thumbnail = await thumbnailsStore.getItem(clonedCandidate[0].id);
                //         if (thumbnail) {
                //             clearInterval(interval);
                //             resolve();
                //         }
                //     }, 100);
                // });
            }
        },

        onCancel() {
            this.selectedItem = null;
            window.UI.hideModal();
        },
    },
};
</script>

<style lang="scss">
#copy-candidate-from-modal {
    width: 50%;
    height: 80%;

    .modal-body-container {
        margin-bottom: 50px;
        overflow-y: scroll;
        scrollbar-color: #989898 transparent;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #989898;
            border-radius: 50px;
        }
    }

    .v-expansion-panel {
        background: transparent;
        color: inherit;

        &:before {
            display: none;
        }

        .v-expansion-panel-header {
            padding: 0;
            min-height: auto;
            flex-direction: row-reverse;
            // margin-bottom: 10px;

            &:before {
                display: none;
            }

            span {
                font-size: 12px;
                font-weight: bold;
            }

            .v-expansion-panel-header__icon i {
                font-size: 18px;
                color: var(--font-default-color);
            }
        }

        .v-expansion-panel-content__wrap {
            margin-bottom: 60px;
            padding: 0;
        }
    }

    .bin-container {
        &:not(:first-of-type) {
            margin-top: 15px;
        }
    }

    .assets-container {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        padding-right: 10px;
        // margin-left: -3px;
        // margin-right: -3px;

        .asset-container {
            min-width: 0;

            .file-thumbnail {
                border-radius: var(--thumbnail-lg-border-radius);
                border: 3px solid transparent;

                &.--selected {
                    border: 3px solid var(--primary);
                }
            }

            .asset-name {
                line-height: 22px;
                font-size: 12px;
                height: 22px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: block;
            }
        }
    }

    .buttons-continer {
        margin-top: auto;
    }
}

#project-tree-copy-candidate-from {
    margin-bottom: 50px;
    height: 300px;
    // scrollbar-width: none;
    background: transparent;
    color: #989898;
    font-size: 1rem !important;

    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: #989898 transparent;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #989898;
        border-radius: 50px;
    }

    .v-icon {
        color: #989898;
    }

    .v-treeview-node__label {
        line-height: 1;
    }

    .v-treeview-node__root:before,
    .v-treeview-node__toggle {
        transition: none;
    }

    .v-treeview-node__toggle:after {
        display: none;
    }

    .thumbnail-container {
        width: 50px;
        height: 35px;
        margin-right: 5px;
        // .file-thumbnail {
        // 	width: 100%;
        // 	height: 100%;
        // 	object-fit: contain;
        // 	padding: 3px 0;
        // 	// border-radius: var(--thumbnail-sm-border-radius);
        // }
    }
}
</style>
